import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './App.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { PeriodBufferProvider } from './context/PeriodBufferContext';
import { ThemeProvider } from './context/ThemeContext';
import { ProfileImageProvider } from './context/ProfileImageContext';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <ProfileImageProvider>
            <PeriodBufferProvider>
              <App />
            </PeriodBufferProvider>
          </ProfileImageProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();